import { connect } from 'react-redux'
import { IPickupNote, IStoreState, ITripEdit } from '../../types/index'
import EditTripModal from '../../components/trips/edit-details/EditTripModal'
import * as actions from '../../state/actions/trips'
import * as riderActions from '../../state/actions/riders'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import * as riderReducers from '../../state/reducers/riders'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const currentTrip = ownProps.currentTrip
  const p = currentTrip.scheduledPickupTime
  const d = currentTrip.scheduledDropoffTime

  return {
    history: ownProps.history,
    match: ownProps.match,
    scheduledPickupTime: p,
    scheduledDropoffTime: d,
    createTrip: ownProps.createTrip,
    cloneTrip: ownProps.cloneTrip,
    cancelTrip: ownProps.cancelTrip,
    enableOtherFields: ownProps.enableOtherFields,
    riders: state.riders.items,
    duration: currentTrip.duration
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchRiders: () => {
      return dispatch(riderActions.getMany({ isArchived: true }))
    },
    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(actions.saveData(params))
    },

    setScheduledTime: (time: string, type: string) => {
      if (type === 'pickup') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest(time))
        ])
      } else if (type === 'dropoff') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest(time)),
          dispatch(actions.actionCreators.setPickupToTripRequest())
        ])
      } else {
        // do nothing
        return
      }
    },
    updateTripNotes: (notes: string) => dispatch(actions.actionCreators.updateTripNotes(notes))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditTripModal)



// WEBPACK FOOTER //
// ./src/containers/trips/EditTripModal.ts